import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";

import { useStoreContext } from "contexts/StoreContext"
import { Button, Card, Typography, IconButton, Modal, Link } from "stories/components";
import { Container, Row, Col } from "stories/layout";
import { Checkbox, Input } from "stories/forms";
import { TableAuto } from "stories/tables";
import Calendar from "components/Calendar/Calendar"
import Chat from "components/Chat/Chat"
// api
import { httpGetCustomerUsers } from "services/customerUsers"

window.mobilecheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function CustomerUsers({ history }) {
  const { enums, isMobile } = useStoreContext();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    type: "customer"
  })
  
  // Chat Modal
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [chatUser, setChatUser] = useState();
  
  const handleChatOpen = (userKey) => {
    // setCalendarUserId(userKey);
    const user = rows && rows.find(row => {
      if (row?.key === userKey) {
        return row;
      }
    })
    if (user) {
      setChatUser(user);
    }
    setIsChatModalOpen(true);
  }
  
  // Calendar Modal
  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);
  const [calendarUserId, setCalendarUserId] = useState();
  const [calendarUser, setCalendarUser] = useState();
  
  const handleToggle = () => {
    setIsCalendarModalOpen(s => !s);
  }
  
  const handleCalendar = (userKey) => {
    // setCalendarUserId(userKey);
    const user = rows && rows.find(row => {
      if (row?.key === userKey) {
        return row;
      }
    })
    if (user) {
      setCalendarUser(user);
    }
    setIsCalendarModalOpen(true);
  }
  
  // Table
  
  const [headers, setHeaders] = useState()
  
  useEffect(() => {
    if (isMobile) {
      setHeaders([
        { label: "Asiakas"},
        { label: ""},
        { label: "Sähköposti"},
        { label: "Puhelinnumero"},
        { label: "Tyyppi"},
        { label: "Tila"},
        { label: "Toimipiste"},
      ])
    }
    else {
      setHeaders([
        { label: "Asiakas"},
        { label: "Sähköposti"},
        { label: "Puhelinnumero"},
        { label: "Tyyppi"},
        { label: "Tila"},
        { label: "Toimipiste"},
        { label: ""},
      ])
    }
  }, [isMobile])
  
  const [rows, setRows] = useState([]);
  
  const handleEdit = (key) => {
    history.push(`/dashboard/customers/edit/${key}/`);
  }
  
  const getStatus = (activatedDate) => {
    
    if (!activatedDate || moment(activatedDate).isBefore(moment())) {
      return (
        <Typography bold className="text-danger">Deaktiivinen</Typography>
      )
    }
    else {
      return (
        <Typography bold className="text-success">Aktiivinen {moment(activatedDate).format("D.M.YYYY")}</Typography>
      )
    }
  }
  
  const getFamilyMembers = (row) => {
    const count = row?.family_members ? row?.family_members.length : 0;
    return row?.family_members && row?.family_members.map((fm, i) => {
      return (
        <span key={i}>{fm?.firstname} {fm?.lastname}{i+1 < count ? ", " : ""}</span>
      )
    })
  }
  
  const getOrganizationUnit = (row) => {
    if (row?.organization_customer?.organization_unit_fk) {
      return `${row?.organization_customer?.organization_fk.name}/${row?.organization_customer?.organization_unit_fk.name}`;
    }
    else {
      return "Ei asetettu";
    }
  }
  
  const getTableRows = useCallback(() => {
    return rows && rows.map(row => {
      let tableRow = []
      tableRow.push((
          <>
            <Link to={`/dashboard/customers/edit/${row?.key}/`}>
              <Typography bold>{row?.firstname} {row?.lastname}</Typography>
            </Link>
            { row?.type === "customer" && (
              <Typography>Omaiset: {getFamilyMembers(row)}</Typography>
            )}
          </>
        ))
        
      if (isMobile) {
        tableRow.push((
          <>
            <IconButton size="xl" onClick={() => handleChatOpen(row?.key)} iconName="chat-round" />
            <IconButton size="xl" onClick={() => handleCalendar(row?.key)} iconName="calendar-grid-58" />
            <IconButton size="xl" onClick={() => handleEdit(row?.key)} iconName="settings-gear-65" />
          </>
        ))
      }
      
      tableRow = [
        ...tableRow,
        (
          <Typography>{row?.email}</Typography>
        ),
        (
          <Typography>{row?.phone}</Typography>
        ),
        (
          <Typography bold>{row?.type === "customer" ? "Seniori" : "Omainen"}</Typography>
        ),
        (
          <>{getStatus(row?.active)}</>
        ),
        (
          <Typography>{getOrganizationUnit(row)}</Typography>
        ),
      ]
      
      if (!isMobile) {
        tableRow.push((
          <>
            <IconButton size="xl" onClick={() => handleChatOpen(row?.key)} iconName="chat-round" />
            <IconButton size="xl" onClick={() => handleCalendar(row?.key)} iconName="calendar-grid-58" />
            <IconButton size="xl" onClick={() => handleEdit(row?.key)} iconName="settings-gear-65" />
          </>
        ))
      }
      
      return tableRow;
      /*
      return [
        (
          <>
            <Link to={`/dashboard/customers/edit/${row?.key}/`}>
              <Typography bold>{row?.firstname} {row?.lastname}</Typography>
            </Link>
            { row?.type === "customer" && (
              <Typography>Omaiset: {getFamilyMembers(row)}</Typography>
            )}
          </>
        ),
        (
          <Typography>{row?.email}</Typography>
        ),
        (
          <Typography>{row?.phone}</Typography>
        ),
        (
          <Typography bold>{row?.type === "customer" ? "Seniori" : "Omainen"}</Typography>
        ),
        (
          <>{getStatus(row?.active)}</>
        ),
        (
          <Typography>{getOrganizationUnit(row)}</Typography>
        ),
        (
          <>
            <IconButton size="xl" onClick={() => handleChatOpen(row?.key)} iconName="chat-round" />
            <IconButton size="xl" onClick={() => handleCalendar(row?.key)} iconName="calendar-grid-58" />
            <IconButton size="xl" onClick={() => handleEdit(row?.key)} iconName="settings-gear-65" />
          </>
        )
      ]
      */
    })
  }, [rows, isMobile])

  const getUsers = () => {
    setLoading(true);
    httpGetCustomerUsers(filters).then(res => {
      setRows(res);
    }).finally(response => {
      setLoading(false);
    })
  }
  
  const handleSubmit = (e) => {
    e.preventDefault()
    getUsers();
  }

  useEffect(() => {
    getUsers()
  }, [])
  
  const getOptionsType = useCallback(() => {
    return enums && enums?.priima?.user?.type.map(obj => {
      return (
        <option value={obj.key}>{obj.key === "customer" ? "Seniori" : "Omainen"}</option>
      )
    })
  }, [enums])
  
    
  const handleFilterChange = ({ target }) => {
    const { value, name } = target;
    setFilters(s => ({
      ...s,
      [name]: value
    }))
  }
  
  
  
  const getChatTitle = () => {
    return `Lähetä uusi viesti ${chatUser ? chatUser?.firstname + " " + chatUser?.lastname : ""}`
  }
  
  return (
    <>
      <Container fluid>
        <Row>
          <div className="col">

              <Row>
                <Col sm="12" md="6" className="mb-2">
                  <Typography bold variant="h2" className="mb-0">Asiakaskäyttäjät</Typography>
                  <Typography className="mb-0">Voit hallita täältä asiakaskäyttäjiä</Typography>
                </Col>
              </Row>
              
              
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xs="12" sm="6" md="3">
                    <Input name="type" type="select" onChange={handleFilterChange} value={filters?.type}>
                      <option value="customer">Seniorit</option>
                      <option value="family">Omaiset</option>
                    </Input>
                  </Col>
                  
                  <Col xs="12" sm="6" md="3" className="mb-2">
                    <Input name="search" onChange={handleFilterChange} value={filters?.search} placeholder="Hae nimellä" />
                  </Col>
                  
                  <Col xs="12" sm="6" md="3">
                    <Input name="active" type="select" onChange={handleFilterChange} value={filters?.active}>
                      <option value="">Kaikki</option>
                      <option value="true">Aktiivinen</option>
                      <option value="false">Ei aktiivinen</option>
                    </Input>
                  </Col>
                  <Col xs="12" sm="6" md="3" className="mb-2">
                    <Button onClick={getUsers}>Hae</Button>
                  </Col>
                </Row>
              </form>
              
              <TableAuto
                checkboxes={false}
                headers={headers}
                rows={getTableRows()}
                loading={loading}
              />

          </div>
        </Row>
      </Container>
      
      <Modal size="modal-lg" isOpen={isChatModalOpen} toggleModal={() => setIsChatModalOpen(!isChatModalOpen)} title={getChatTitle()}>
        <Chat user={chatUser} />
      </Modal>
      
      <Modal fullscreen={window.mobilecheck()} isOpen={isCalendarModalOpen} toggleModal={() => setIsCalendarModalOpen(!isCalendarModalOpen)} title={`${calendarUser?.firstname} ${calendarUser?.lastname} kalenteri`}>
        <Calendar user={calendarUser} />
      </Modal>
      
    </>
  );
}

export default CustomerUsers;
